import { WidgetNames } from '@finxone-platform/shared/sys-config-types';

export class ProgressBarImageAction {
  static readonly type = '[Progress Bar Widget] ProgressBarImageAction';
  constructor(public widgetName: WidgetNames) {}
}

export class ProgressBarImageSelected {
  static readonly type = '[Progress Bar Widget] ProgressBarImageSelected';
}
